var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderManageProduct',{attrs:{"img_header":_vm.header_image,"header":"ประวัติการตั้งราคา (Pricing history)","link_back":_vm.link_back}}),_c('Pricing_history_product_regular_accessorie_part')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }